module.exports = __webpack_public_path__ + "static/media/time-session-3h.2a0f1d05.svg";